var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "common_header" }, [
    _c("div", { staticClass: "search" }, [
      _c("div", { staticClass: "pageTitle" }, [_vm._v(_vm._s(_vm.pageTitle))]),
      _c(
        "div",
        { staticClass: "searchRight" },
        [
          _c("el-input", {
            staticClass: "my_input centerSearch",
            attrs: { placeholder: _vm.placeholderArea, clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.searchClick.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchKey,
              callback: function ($$v) {
                _vm.searchKey = $$v
              },
              expression: "searchKey",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "rightSearchBtn height_four",
              attrs: { type: "primary" },
              on: { click: _vm.searchClick },
            },
            [_vm._v("搜索")]
          ),
          _c(
            "el-button",
            {
              staticClass: "height_four",
              attrs: { type: "text" },
              on: { click: _vm.openClick },
            },
            [
              _vm._v("高级搜索 "),
              !_vm.showFlag
                ? _c("span", { staticClass: "el-icon-arrow-down" })
                : _c("span", { staticClass: "el-icon-arrow-up" }),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }